<script setup lang="ts">
import type { MultiHeroBlockV2 } from '~/types/storyblok/multi-hero-block-v2'
import type { trackBlockClickEmit } from '~/types/track-block-click'

interface Props {
  blok: MultiHeroBlockV2
}

const props = defineProps<Props>()
defineEmits<trackBlockClickEmit>()
const blok = toRef(props, 'blok')
</script>

<template>
  <div v-if="blok" class="multihero">
    <div
      v-for="(component, index) in blok.heroBlocks"
      :key="component._uid"
      class="multihero__component"
    >
      <component
        :is="component.component"
        :key="component._uid"
        :blok="component"
        :multi-hero-index="index"
        :data-position="$attrs['data-position']"
        @track-block-click="(url: string, clickType: string) => $emit('trackBlockClick', url, clickType)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.multihero {
  display: flex;
  flex-direction: column;
}

@media (min-width: $large-breakpoint) {
  .multihero {
    flex-direction: row;
    &__component {
      width: 50%;
    }
  }
}
</style>
